export default "__VITE_ASSET__B_6b7bEG__"